import { CommApiInstance } from "Utils/CommApiInstance";

const MenbFindIdLstApi = async (
    idntMthdCd:string
) => {
    
    return await CommApiInstance.post(`comm/find/login_id_lst`,{
        apiBody:{
            idntMthdCd:idntMthdCd,
        },
    })
    .then((Resp) => Resp.data);
    
}
export default MenbFindIdLstApi;